<template>
    <div v-if="isSlim" style="display: flex; justify-content: space-between; align-items: center">
        <p class="stack-s no-margin-bottom">{{bankAccount.name}} — {{bankAccount.type}} <v-icon icon="bank"/></p>
    </div>
    <div v-else-if="isCompact" class="grid-fitted grid-unstackable">
        <div class="grid-item no-flex inline-s">
            <v-icon icon="bank"/>
        </div>
        <div class="grid-item grid-item-primary">
            <p>{{bankAccount.name}}</p>
            <p>
                Routing No.
                <code class="text inline-s">{{bankAccount.routing}}</code>
            </p>
            <p>
                {{bankAccount.type}} account
                <code class="text inline-s">*{{bankAccount.lastFour}}</code>
            </p>
            <v-contact :contact="bankAccount.address"></v-contact>
            <contact-form-modal
                v-if="isAddressEditable && hasInjectedMethods"
                title="Edit Address"
                class="no-flex"
                :value="instrument.address"
                :custom-fields="contactsCustomFields"
                @input="updateContact($event)"
                :can-delete="false"/>
        </div>
        <div class="grid-item no-flex inline-s">
            <instrument-fingerprint :fingerprint="fingerprint"/>
        </div>
    </div>
    <div v-else>
        <div class="grid-fitted grid-unstackable">
            <div class="grid-item">
                <p class="stack-s">{{bankAccount.name}} — {{bankAccount.type}}</p>
            </div>
            <div class="grid-item no-flex">
                <instrument-fingerprint :fingerprint="fingerprint"/>
                <v-icon icon="bank"/>
            </div>
        </div>
        <p class="text-muted">Routing Number</p>
        <p class="payment-instrument-bank-routing stack-m">{{bankAccount.routing}}</p>
        <p class="payment-instrument-bank-customer">{{bankAccount.customer}}</p>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import fullName from '@/common/helpers/full-name';
    import vContact from '@/components/v-contact';
    import ContactModel from '@/common/models/contact-model';
    import ContactFormModal from '@/components/contact-manager/contact-form-modal';
    import _ from '@/common/helpers';
    import InstrumentFingerprint from '../instrument-fingerprint';

    export default {
        name: 'ach-view',
        inject: {
            updatePaymentInstrument: {default: null},
            contactsCustomFields: {default: null},
        },
        components: {
            vIcon,
            InstrumentFingerprint,
            vContact,
            ContactFormModal,
        },
        props: {
            instrument: Object,
            isCompact: {
                type: Boolean,
                default: true,
            },
            isSlim: {
                type: Boolean,
                default: false,
            },
            isAddressEditable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            hasInjectedMethods() {
                return this.updatePaymentInstrument !== null
                    && this.contactsCustomFields !== null;
            },
            fingerprint() {
                return this.instrument.fingerprint;
            },
            bankAccount() {
                return {
                    customer:
                        fullName(this.instrument.address),
                    name: this.instrument.name || this.instrument.bankName,
                    type: _.capitalize(this.instrument.accountType),
                    routing: this.instrument.routingNumber,
                    lastFour: this.instrument.last4,
                    address: new ContactModel(this.instrument.address),
                };
            },
        },
        methods: {
            updateContact(data) {
                this.updatePaymentInstrument({instrument: this.instrument, data});
            },
        },
    };
</script>
